import { toastMessages } from '../utils';
import { useToast } from './useToast';

export const useApiError = (): {
    handleApiError: (status: number) => void;
} => {
    const { showToast } = useToast();

    const handleApiError = (status: number): void => {
        if (status) {
            switch (status) {
                case 400:
                    showToast(toastMessages.error.badRequest);
                    break;
                case 401:
                    showToast(toastMessages.error.unauthorized);
                    break;
                case 403:
                    showToast(toastMessages.error.forbidden);
                    break;
                case 404:
                    showToast(toastMessages.error.notFound);
                    break;
                case 422:
                    showToast(toastMessages.error.unprocessable);
                    break;
                case 500:
                    showToast(toastMessages.error.serverError);
                    break;
                case 502:
                case 503:
                case 504:
                    showToast(toastMessages.error.gatewayError);
                    break;
                default:
                    showToast(toastMessages.error.default);
                    break;
            }
        }
    };

    return {
        handleApiError
    };
};